import { render, staticRenderFns } from "./BaseMerits.html?vue&type=template&id=7b383d58&external"
import script from "./BaseMerits.ts?vue&type=script&lang=ts&external"
export * from "./BaseMerits.ts?vue&type=script&lang=ts&external"
import style0 from "./BaseMerits.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports